import { throttle } from 'lodash';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState, useRef } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import styles from './trainings-nav.module.scss';

export default function TrainingsNav({ slug, type = 'trainings' }) {
  const router = useRouter();

  const isActiveLink = (link) => (router.asPath === link ? styles.active : '');

  const [prevScrollpos, setPrevScrollpos] = useState(0);
  const [currentScrollpos, setcurrentScrollpos] = useState(0);
  const [scrollDown, setScrollDown] = useState(false);
  const introRef = useRef(null);

  useEffect(() => {
    updateNavbarOnScroll();
    window.addEventListener('scroll', updateNavbarOnScroll);

    return () => {
      window.removeEventListener('scroll', updateNavbarOnScroll);
    };
  }, []);

  useEffect(() => {
    if (prevScrollpos > currentScrollpos) {
      setScrollDown(false);
    } else {
      setScrollDown(true);
    }
    setPrevScrollpos(currentScrollpos);
  }, [currentScrollpos]);

  const updateNavbarOnScroll = () => {
    setcurrentScrollpos(window.pageYOffset);
  };

  return (
    <div ref={introRef}>
      <ScrollContainer
        vertical={false}
        style={{ position: currentScrollpos > 89 && 'fixed' }}
        className={`${styles.navBar} ${scrollDown && styles.scrollDown}`}
      >
        <Link className={isActiveLink(`/${type}/${slug}`)} href={`/${type}/${slug}`}>
          Overview
        </Link>
        <Link className={isActiveLink(`/${type}/${slug}/location`)} href={`/${type}/${slug}/location`}>
          Location
        </Link>
        <Link className={isActiveLink(`/${type}/${slug}/program`)} href={`/${type}/${slug}/program`}>
          Program
        </Link>
        {type === 'trainings' && (
          <Link className={isActiveLink(`/${type}/${slug}/prerequisites`)} href={`/${type}/${slug}/prerequisites`}>
            Prerequisites
          </Link>
        )}

        <Link href={`/${type}/${slug}#testimonials`}>Testimonials</Link>
        <Link href={`/${type}/${slug}#${type == 'retreats' ? 'teachers' : 'faculty'}`}>
          {type == 'retreats' ? 'Teachers' : 'Faculty'}
        </Link>
        <Link href={`/${type}/${slug}#booknow`}>Book</Link>
      </ScrollContainer>
    </div>
  );
}
